const createAnimationHasDownloadedSelector = (
    state: sage.state.IRedux
): boolean => {
    return state.createAnimation.hasDownloaded;
};

export default createAnimationHasDownloadedSelector;
